export const environment = {
  production: true,
  apiUrl: 'https://testevent.susoft.com/api/v2',
  uploadsUrl: '/uploads',
  captchaKey: '6LeCD6YZAAAAAF4t_PwmhU3RlUdrA0TslsZdvi0n',
  orderTimeoutMinutes: 2880,
  googleClientId:
    '684096719695-3jmkp8ph00gps63eu9snc6amdh4vhm47.apps.googleusercontent.com',
  googlePlaceApiKey: 'AIzaSyDu2e2-jV2AbQM0qfjlCKylbw0oblhqPHc',
  orderXTicketPrefix: '1ET1',
  orderXUrl: 'https://testorderx.susoft.com'
};
